import { useEmployeeEditingCtx } from '@/app/(app)/settings/employees/[id]/provider';
import { Select } from '@/components/atoms/select';
import { SuperUserOnly } from '@/components/providers/admin-only';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Switch } from '@/components/ui/switch';
import { EMPLOYEE_ROLES } from '@/consts/enums';

export function EmployeeDetails() {
  const { employee, update } = useEmployeeEditingCtx();

  return (
    <div className='flex w-full flex-col gap-14'>
      <div className='flex flex-col'>
        <h2 className='pb-3 text-heading-md'>Status</h2>
        <div className='flex flex-col border-t-[0.5px]'>
          <div className='flex items-start gap-2 py-3'>
            <Switch
              checked={employee.status === 'ACTIVE'}
              onCheckedChange={(checked) => update({ status: checked ? 'ACTIVE' : 'INACTIVE' })}
              disabled
            />
            <div className='flex flex-col gap-[3px] pt-0.5'>
              <Label className='leading-none'>Active Status</Label>
              <span className='text-sm text-muted-foreground'>Enable or disable this employee.</span>
            </div>
          </div>
          <div className='flex items-start gap-2 py-3'>
            <Switch checked={employee.bookable} onCheckedChange={(checked) => update({ bookable: checked })} />
            <div className='flex flex-col gap-[3px] pt-0.5'>
              <Label className='leading-none'>Bookable</Label>
              <span className='text-sm text-muted-foreground'>Is this employee available for scheduling?</span>
            </div>
          </div>
        </div>
      </div>
      <div className='flex flex-col gap-4'>
        <h2 className='text-heading-md'>Details</h2>
        <div className='grid gap-x-2 gap-y-4 md:grid-cols-2'>
          <div className='space-y-2'>
            <Label>First Name</Label>
            <Input disabled value={employee.first_name} onChange={(e) => update({ first_name: e.target.value })} />
          </div>
          <div className='space-y-2'>
            <Label>Last Name</Label>
            <Input disabled value={employee.last_name} onChange={(e) => update({ last_name: e.target.value })} />
          </div>
          <div className='space-y-2'>
            <Label>Email</Label>
            <Input disabled value={employee.email} onChange={(e) => update({ email: e.target.value })} />
          </div>
          <div className='space-y-2'>
            <Label>Phone Number</Label>
            <Input
              disabled
              value={employee.phone_number ?? ''}
              onChange={(e) => update({ phone_number: e.target.value })}
            />
          </div>
          <div className='space-y-2'>
            <Label>Employee Role</Label>
            <Select
              disabled
              options={EMPLOYEE_ROLES}
              value={employee.role}
              onChange={(value) => update({ role: value })}
              className='w-full'
            />
          </div>
        </div>
      </div>
      <SuperUserOnly>
        <div className='flex flex-col gap-4'>
          <h2 className='text-heading-md'>Super Admin Settings</h2>
          <div className='col-span-2 space-y-2'>
            <Label>User ID</Label>
            <Input value={employee.user_id ?? ''} onChange={(e) => update({ user_id: e.target.value })} />
          </div>
        </div>
      </SuperUserOnly>
    </div>
  );
}
